import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

const { heading5Obj, textSObj, textXSObj } = typographyStyles;

const getPopOutContainerBackgroundColor = (
  isLite: boolean,
  isImpersonated: boolean,
) => {
  if (isImpersonated) {
    return constants.colors.ui.red[700];
  }

  if (isLite) {
    return constants.colors.ui.black[700];
  }

  return constants.colors.ui.core[500];
};

export const userPopoutContainerCss = (
  isLite: boolean,
  isImpersonated: boolean,
): CSSObject => ({
  display: "flex",
  flexDirection: "column",
  padding: "1rem",
  alignItems: "flex-start",
  borderRadius: "0.5rem 0.5rem 0 0",
  background: getPopOutContainerBackgroundColor(isLite, isImpersonated),

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    borderRadius: 0,
  },
});

export const userNameTextCss: CSSObject = {
  ...heading5Obj,
  color: constants.colors.ui.white[50],
  fontWeight: 700,
  textAlign: "left",
  margin: 0,
};

export const userDetailsCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "0.5rem",
};

export const userRoleTextCss: CSSObject = {
  ...textXSObj,
  color: constants.colors.ui.white[50],
  letterSpacing: "1px",
  textTransform: "uppercase",
  textAlign: "left",
};

export const userEmailText: CSSObject = {
  ...textSObj,
  textAlign: "left",
  wordBreak: "break-all",
  color: constants.colors.ui.white[50],
};
